/**
 * @file コンポーネント：プライバシーポリシー英語 ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const PrivacypolicyEnglish = () => {
    // Presenterに渡す
    return <Presenter />;
};
